import React, { createContext, useState, useContext, useEffect } from 'react';
import { login as loginApi, getMe } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // Cached user'ı senkron oku — loading=false ile başla, sayfayı bekletme
  const [user, setUser] = useState(() => {
    try {
      const cached = localStorage.getItem('user');
      return cached ? JSON.parse(cached) : null;
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Token varsa arkaplanda doğrula (UI'ı bloklama)
    const token = localStorage.getItem('token');
    if (!token) return;
    getMe()
      .then((response) => {
        setUser(response.data);
        localStorage.setItem('user', JSON.stringify(response.data));
      })
      .catch(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setUser(null);
      });
  }, []);

  const login = async (credentials) => {
    const response = await loginApi(credentials);
    const { user, token } = response.data;
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    setUser(user);
    return user;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  const isAdmin = user?.role === 'admin';
  const isTechnician = user?.role === 'admin' || user?.role === 'technician';
  const canDelete = isAdmin || !!user?.canDelete;
  const isOgs = user?.username === 'ogs';

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isAdmin, isTechnician, canDelete, isOgs }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
